module.exports = "/virtual-football-league/img/livescore.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/livescore.jpg
// module id = 184
// module chunks = 4